import { AppShell, Stack } from "@mantine/core"
import { ReactElement } from "react"

import { IconProps } from "../../icons/nav-icons/icon.types.ts"
import { NavBarItem } from "../../layout/NavBarItem/NavBarItem.tsx"

export type NavItem = {
  link: string
  label: string
  Icon: ({ hovered, ...props }: IconProps) => ReactElement
}
type Props = {
  navItems: NavItem[]
  settingsItems?: NavItem[]
}
export const AppNavBar = ({ navItems, settingsItems }: Props) => {
  return (
    <AppShell.Navbar
      withBorder={false}
      style={{
        backgroundColor: "var(--mantine-color-green-6)",
        width: "70px",
      }}
    >
      <Stack h="100%" py={60} justify="space-between">
        <Stack>
          {navItems.map((item) => (
            <NavBarItem item={item} key={item.link} />
          ))}
        </Stack>
        <Stack>
          {settingsItems?.map((item) => (
            <NavBarItem item={item} key={item.link} />
          ))}
        </Stack>
      </Stack>
    </AppShell.Navbar>
  )
}
